import React from 'react';
import PropTypes from 'prop-types';

import { InsOutsPlayer } from './InsOutsPlayer';

/**
 * Renders the wrapper and title for a single team.
 *
 * @param data
 * @param {object} data.data The Ins/Outs player data.
 * @param {string} data.title The value printed to the section, i.e. 'IN' or 'OUT'.
 * @param {string} data.matchTitle The match title, e.g. 'Sydney Swans v GWS GIANTS'.
 * @param {string} data.cssClass The CSS class that is applied to the title, i.e. 'in' or 'out'.
 * @param {string} data.teamDisplay The team to display, i.e. 'home' or 'away'.
 * @param {string} data.competitionId Competition providerId.
 * @returns {JSX.Element} The Ins/Outs row for a single team.
 */
export const InsOutsRowSingle = ({
    data,
    title,
    matchTitle,
    cssClass,
    teamDisplay,
    competitionId
}) => {
    const renderPlayer = (item, match) => {
        if (!item) {
            return null;
        }

        const isAFLW =
            PULSE.app.common.match.getCompAbbr(competitionId).toLowerCase() ===
            'aflw';

        const player = item.player ? item.player : item;

        return (
            <InsOutsPlayer
                key={player.playerId}
                data={data}
                player={player}
                reason={item.reason}
                match={match}
                isAFLW={isAFLW}
                matchTitle={matchTitle}
            />
        );
    };

    return (
        <div className="team-lineups-condensed-embeddable__ins-and-outs">
            <div className="team-lineups-condensed-embeddable__ins-and-outs-single">
                <div className="team-lineups-condensed-embeddable__ins-and-outs-single-label">
                    <div className="team-lineups-ins-and-outs__title-wrapper">
                        <p
                            className={`team-lineups-ins-and-outs__title ${
                                cssClass
                                    ? `team-lineups-ins-and-outs__title--${cssClass}`
                                    : ''
                            }`}
                        >
                            {title}
                        </p>
                    </div>
                </div>
                <div className="team-lineups-condensed-embeddable__ins-and-outs-single-value">
                    {teamDisplay === 'home' ? (
                        data.home.length ? (
                            <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--home">
                                {[...data.home]
                                    .reverse()
                                    .map((item) =>
                                        renderPlayer(item, data.match)
                                    )}
                            </div>
                        ) : (
                            <span className="team-lineups-ins-and-outs__empty team-lineups-ins-and-outs__empty--home">
                                &ndash;
                            </span>
                        )
                    ) : teamDisplay === 'away' ? (
                        data.away.length ? (
                            <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--away">
                                {data.away.map((item) =>
                                    renderPlayer(item, data.match)
                                )}
                            </div>
                        ) : (
                            <span className="team-lineups-ins-and-outs__empty team-lineups-ins-and-outs__empty--away">
                                &ndash;
                            </span>
                        )
                    ) : null}
                </div>
            </div>
        </div>
    );
};

InsOutsRowSingle.propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    matchTitle: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    teamDisplay: PropTypes.string.isRequired,
    competitionId: PropTypes.string
};
